import React from 'react';

export default function FormField({ label, name, value, onChange, type = 'text', required = false, hint = '', blockPaste = false }) {
  const handlePaste = (e) => {
    if (blockPaste) {
      e.preventDefault();
    }
  };

  return (
    <div className="form-group">
      <label htmlFor={name}>
        {label} {required && <span className="required-asterisk">*</span>}
      </label>
      <input
        id={name}
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        onPaste={handlePaste}
        required={required}
        className="form-input"
      />
      {hint && <small className="field-hint">{hint}</small>}
    </div>
  );
}
